import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

import { Box, TextField, Stepper, Step, StepLabel } from "@mui/material";
import { statusNewNames } from '../../utils/StatusUtils';
import "../../css/Inbound.css";
const ShowStatusDialog = ({ open, onClose, allStatus, inboundRowSelected }) => {

    const statusColors = {
        pendiente: "#2196F3", // Azul
        "hora de arribo a carga": "#FF9800", // Naranja
        "liberacion de carga": "#FFEB3B", // Amarillo
        "arribo a descargar": "#4CAF50", // Verde
        "liberacion de descarga": "#8BC34A", // Verde claro
        "arribo a terminar vacio": "#F44336", // Rojo
        "salida de terminal": "#9E9E9E", // Gris
    };


    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Estado</DialogTitle>
            <DialogContent>

                <Stepper activeStep={inboundRowSelected?.id_status_of_inbound} alternativeLabel>
                    {allStatus.map((item, index) => {
                        const isActive = index <= (inboundRowSelected?.id_status_of_inbound - 1);

                        return (
                            <Step key={index}>
                                <StepLabel
                                    slotProps={{
                                        stepIcon: {
                                            style: { color: isActive ? statusColors[item?.estatus] : "#BDBDBD" }, // Solo los activados tienen color, los demás son grises
                                        },
                                    }}
                                    sx={{
                                        "& .MuiStepLabel-label": {
                                            color: isActive ? statusColors[item?.estatus] : "#BDBDBD", // Texto gris si no está activo
                                        },
                                        "& .MuiStepConnector-line": {
                                            borderColor: isActive ? statusColors[item?.estatus] : "#E0E0E0", // Línea gris si no está activo
                                        },
                                    }}
                                >
                                    {statusNewNames[item?.estatus]}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>

            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // Centra los botones
                    paddingBottom: 2, // Espaciado inferior
                }}
            >
                <Button
                    onClick={() => onClose()}
                    variant="contained"
                    color="primary"
                    sx={{
                        marginLeft: 2, // Espaciado entre botones
                        width: 'auto',
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ShowStatusDialog;
